<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-app :class="{ loggedIn: getIsLoggedIn }" class="OneLinkNoTx">
    <NotificationQueue></NotificationQueue>
    <slot name="header" />
    <TheGlobalTopBanner v-if="showTopBanner"></TheGlobalTopBanner>
    <TheSidebar
      v-if="showSideBar"
      :items="sidebarItems"
      :use-fleet-admin-navigation="useFleetAdminNavigation"
    ></TheSidebar>
    <v-content :style="{ marginTop: bannerHeight + 'px' }">
      <div
        class="continue-onboarding-button"
        v-if="
          getIsLoggedIn &&
          (!hasSignedFFMTermsAndConditions ||
            !hasSignedProductTermsAndConditions) &&
          $route.path === '/manage-cookies'
        "
      >
        <v-btn
          color="primary"
          class="white--text"
          @click="$router.push('/onboard')"
          data-qa="goToOnboardScreen"
          >{{ $t('cookieManagement.goToOnboard') }}
        </v-btn>
      </div>
      <router-view></router-view>
      <slot name="footer" />
    </v-content>
    <InitialSignOnDialogs></InitialSignOnDialogs>
    <FordProRedirectingOverlay />
    <slot name="dialogs" v-bind:canUseFFMApplication="canUseFFMApplication" />
  </v-app>
</template>

<script>
import TheSidebar from '@/components/TheSidebar';
import { mapGetters } from 'vuex';
import NotificationQueue from '@/components/NotificationQueue';
import InitialSignOnDialogs from '@/components/InitialSignOnDialogs';
import SubscribeToStore from '@/mixins/SubscribeToStore';
import { TopBannerHeight } from '@/mixins/TopBannerHeight';
import TheGlobalTopBanner from '@/components/TheGlobalTopBanner.vue';
import FordProRedirectingOverlay from '@/components/FordProRedirectingOverlay';

export default {
  name: 'App',
  components: {
    TheGlobalTopBanner,
    TheSidebar,
    NotificationQueue,
    InitialSignOnDialogs,
    FordProRedirectingOverlay,
  },
  mixins: [SubscribeToStore('subscribeCallBack'), TopBannerHeight],
  props: {
    sidebarItems: Array,
    useFleetAdminNavigation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      notificationRecipient: '',
      analyticsUser: '',
      userActivityTimeout: null,
    };
  },
  mounted: async function () {
    if (localStorage.getItem('firstEvent') === null) {
      localStorage.setItem('firstEvent', 'true');
    }
  },
  computed: {
    ...mapGetters('auth', ['getApplications', 'getIsLoggedIn']),
    ...mapGetters('termsAndConditions', [
      'hasFetchedTermsAndConditions',
      'hasSignedFFMTermsAndConditions',
      'hasSignedProductTermsAndConditions',
      'canViewOnboardPage',
    ]),
    canUseFFMApplication() {
      for (const item of this.getApplications) {
        if (
          item.name === 'administrativeConsole' ||
          item.name === 'admin_internal' ||
          item.name === 'dataSharingAuthorization'
        ) {
          return true;
        }
      }
      return false;
    },
    showTopBanner() {
      let inFPGApp = this.useFleetAdminNavigation;
      let currentPath = window.location.pathname;
      let inVehiclePath =
        currentPath.includes('/fleet-admin/vehicles') ||
        currentPath.endsWith('/fleet-admin/') ||
        currentPath.endsWith('/fleet-admin');
      let inUserPath = currentPath.includes('/fleet-admin/users');
      return inFPGApp && (inVehiclePath || inUserPath);
    },
    showSideBar() {
      let fetchedAndSignedTermsAndConditions =
        this.hasFetchedTermsAndConditions &&
        this.hasSignedFFMTermsAndConditions &&
        this.hasSignedProductTermsAndConditions;
      let isReadyToOnboard =
        !fetchedAndSignedTermsAndConditions ||
        this.$route.path.startsWith('/onboard');
      let isOnboarding = this.canViewOnboardPage && isReadyToOnboard;
      return (
        this.getIsLoggedIn &&
        !isOnboarding &&
        this.canUseFFMApplication &&
        this.sidebarItems
      );
    },
  },
  methods: {
    subscribeCallBack(mutation) {
      if (mutation.type === 'auth/SET_USER_INFO') {
        let userId = mutation.payload.userId;
        if (this.analyticsUser !== userId) {
          this.analyticsUser = userId;
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import './styles/styles.scss';
@import './assets/compiled-icons/icons.css';
@import './styles/font-awesome-pro/scss/light.scss';

.app-background-color {
  background-color: #eee;
}

.continue-onboarding-button {
  position: absolute;
  right: 20px;
  top: 2%;

  .v-btn {
    border-radius: 5px;
    text-transform: none;
  }
}

.v-tabs__item {
  outline-offset: -2px;
}
</style>
